'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _util = require('./util');

var _themeA11y = require('@shopify/theme-a11y');

require('./vendor.js')();

// import {cookiesEnabled} from '@shopify/theme-cart';


// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if ((0, _util.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function wrapTable(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function wrapIframe(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:section:reorder', this._onReorder.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function _onSectionUnload(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function _onSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function _onDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function _onReorder(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function _onBlockSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function _onBlockDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function register(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
      console.log(type);
    }.bind(this));
  }

});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = function () {
  var moneyFormat = '£{{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
}();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
}();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {

    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    console.log(this.singleOptionSelector);
    // $('.selector-wrapper').on('change', this._onSelectChange.bind(this));
    $(this.singleOptionSelector).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function _onSelectChange() {
      console.log("variant change");
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateVariantTitle(variant);
      this._backInStock(variant);
      this.currentVariant = variant;
      this._updateHistoryState(variant);
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function _updateImages(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    _backInStock: function _backInStock(variant) {
      if (!variant.available) {
        $('.bis-button').show();
      } else {
        $('.bis-button').hide();
      }
    },

    _updateVariantTitle: function _updateVariantTitle(variant) {
      $('.js--product-header__size').html(variant.title);
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function _updatePrice(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function _updateMasterSelect(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
}();

theme.Swatch = function () {

  var $swatch = $('.js-swatch');

  $swatch.on('click', swatchChange);

  function swatchChange() {
    var $this = $(this),
        optionIndex = $this.closest('[data-swatch]').attr("data-option-index"),
        swatchValue = $this.find("input[type=radio]").first().val();

    $this.closest("[data-swatch]").find(".js-swatch").removeClass('active');
    $this.addClass('active');
    $('#SingleOptionSelector-' + optionIndex).val(swatchValue).trigger('change');
  }

  $("[data-single-option-selector]").each(function () {
    var v = $(this).val(),
        option = $(this).attr('data-option');

    var sw = $(".swatch-" + option).find('[data-value="' + v + '"]').first();
    sw.trigger("click").find("input").trigger("change").trigger('click');

    $(this).trigger("change");
  });
}();

theme.Product = function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productSliderVariant: '[data-slick-variant]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $('.product');

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    console.log(this.$container);
    if (!$(selectors.productJson).html()) {
      return;
    }

    console.log("in the product function");
    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage);
    this.$sliderImage = $(selectors.productSliderVariant);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    // this.$container.trigger('variantChange');
    $("[data-single-option-selector]").trigger("change");
    console.log(this.featuredImage);
    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      // } else if (this.$sliderImage.length > 0) {
      //   this.$container.on('variantImageChange' + this.namespace, this.updateProductSlider.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */

    updateAddToCartState: function updateAddToCartState(evt) {

      var variant = evt.variant;
      console.log(variant);
      if (variant) {
        $(selectors.priceWrapper).removeClass('hide');
      } else {
        $(selectors.addToCart).prop('disabled', true);
        $(selectors.addToCartText).html(theme.strings.unavailable);
        $(selectors.priceWrapper).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart).prop('disabled', false);
        // $('#AddToCart').removeClass('button--hide');
        // $('.BIS_trigger').addClass('button--hide');
        $(selectors.addToCartText).html(theme.strings.addToCart);
      } else {

        $(selectors.addToCart).prop('disabled', true);
        // $('#AddToCart').addClass('button--hide');
        // $('.BIS_trigger').removeClass('button--hide');
        $(selectors.addToCartText).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function updateProductPrices(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        // $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        // $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function updateProductImage(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);
      console.log("Image updated");
      console.log(variant);

      $("[data-thumbnail-color]").hide();
      $("[data-thumbnail-color]").each(function () {
        var thiscolor = $(this).attr('data-thumbnail-color');
        if (thiscolor != "") {
          for (var i in variant.options) {
            if (variant.options[i] == thiscolor) {
              $(this).show();
            }
          }
        } else {
          $(this).show();
        }
      });
    },

    updateProductSlider: function updateProductSlider(evt) {
      var variant = evt.variant.id;
      this.$sliderImage = $(selectors.productSliderVariant);

      this.$sliderImage.each(function (index, value) {
        var slickSlide = $(this).attr('data-slick-variant');
        var slickVar = parseInt(slickSlide);
        if (slickVar == variant) {
          var slideNo = $(this).attr('data-slick-index');
          $('.main-product-slider').slick('slickGoTo', slideNo);
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function onUnload() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
}();
window.xProduct = theme.Product;

theme.ProductSlider = function () {

  var $slider = $('#product-images');

  function productSlider() {
    if ($(window).width() < 750) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1,
          arrows: false,
          dots: false
        });
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  productSlider();

  $(window).resize(function () {
    productSlider();
  });
}();

theme.Accordion = function () {

  var $title = $(".accordion__title"),
      $content = $('.accordion__content'),
      activeClass = 'accordion__content--is-active',
      activeClassParent = 'accordion__item--is-active';

  $title.bind('click', accordionOpen);

  function accordionOpen() {
    var $this = $(this),
        toggleData = $this.attr('data-toggle');

    $content.removeClass(activeClass);
    $content.parent().removeClass(activeClassParent);
    $('#' + toggleData).addClass(activeClass);
    $('#' + toggleData).parent().addClass(activeClassParent);
  }
}();

theme.SizeGuide = new function () {

  var selectors = {
    $sizeGuideTrigger: $('.js--size-guide'),
    $sizeGuideClose: $('.size-guide__close, .size-guide__background'),
    $sizeGuidePanel: $('.size-guide__wrapper'),
    activeClass: 'size-guide--show',
    $mesurementsToggle: $('.size-guide__toggle'),
    $body: $('body'),
    noScrollClass: 'no-scroll'

  };

  selectors.$sizeGuideTrigger.on('click', function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    openSizeGuide();
  });

  selectors.$sizeGuideClose.on('click', function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    closeSizeGuide();
  });

  selectors.$mesurementsToggle.on('click', function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    mesurementsToggle($(this));
  });

  var openSizeGuide = function openSizeGuide() {
    selectors.$sizeGuidePanel.addClass(selectors.activeClass);
    selectors.$body.addClass(selectors.noScrollClass);
  };

  var closeSizeGuide = function closeSizeGuide() {
    selectors.$sizeGuidePanel.removeClass(selectors.activeClass);
    selectors.$body.removeClass(selectors.noScrollClass);
  };

  selectors.$body.bind('touchmove', function (e) {
    // if ($('.'+selectors.noScrollClass).length == 1){
    if (e.target == $('.size-guide') || e.target.parentNode == $('.size-guide__body')) {
      // console.log('anythign');
      e.preventDefault();
      return false;
    }
    // if (e.target == $('.size-guide__body')){
    // } else{
    // }
    // }
  });

  var mesurementsToggle = function mesurementsToggle(x) {
    var $this = x,
        size = $this.attr('data-size');

    selectors.$mesurementsToggle.removeClass('active');
    $this.addClass('active');

    $('.size-guide__measurement').hide();
    $('.' + size).show();
  };

  this.onSectionLoad = function (target) {};
}();

theme.NotificationBar = function () {

  var $notificationBar = $('.notification-bar--carousel');

  $notificationBar.slick(getSliderSettings());

  function getSliderSettings() {
    return {
      arrows: true,
      vertical: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="slick-arrow slick-prev"></div>',
      nextArrow: '<div class="slick-arrow slick-next"></div>'
    };
  }

  return {
    sliderSettings: getSliderSettings
  };
}();

theme.Navigation = function () {

  var $navtoggle = $('.js-toggle-nav'),
      $gendertoggle = $('.mobile-shop--gender-toggle li');

  $navtoggle.on('click', mobileNavigation);

  $gendertoggle.on('click', gendertoggle);

  function mobileNavigation() {
    $('body').toggleClass('js--mobile-menu-open');
  };

  function gendertoggle() {
    var newActive = $(this).attr('data-toggle');

    $gendertoggle.removeClass('active');
    $(this).addClass('active');

    $('.mobile-shop--nav').removeClass('active');
    $('.' + newActive).addClass('active');
  };
}();

theme.Meganav = function () {

  var $siteNavList = $('.site-nav li'),
      $siteDropdown = $('.meganav'),
      $HeaderWrapper = $('#HeaderWrapper');

  $siteNavList.on('mouseenter', showMeganav);

  $siteDropdown.on('mouseleave mousedown', function (e) {
    if (e.type != 'mousedown' && e.originalEvent.buttons != 2) {
      $siteDropdown.removeClass('meganav--show');
      $HeaderWrapper.removeClass('HeaderWrapper--transparent');
    }
  });

  function showMeganav() {

    var $this = $(this),
        $parentId = $this.data('meganav-parent'),
        megaNavTrue = false;

    $siteDropdown.removeClass('meganav--show');
    $HeaderWrapper.addClass('HeaderWrapper--transparent');

    $siteDropdown.each(function () {
      var $childId = $(this).data('meganav-child');

      if ($parentId == $childId) {
        $(this).addClass('meganav--show');
        megaNavTrue = true;
      }
    });

    if (megaNavTrue == false) {
      $HeaderWrapper.removeClass('HeaderWrapper--transparent');
    }
  }
}();

theme.MeganavSection = function MeganavSection() {};

theme.MeganavSection.prototype = $.extend({}, theme.MeganavSection.prototype, {
  onBlockSelect: function onBlockSelect(e) {
    var blockId = e.detail.blockId;
    $('#Meganav-' + blockId).addClass('meganav--show');
  },
  onBlockDeselect: function onBlockDeselect() {
    $('.meganav').removeClass('meganav--show');
  }
});
theme.StickNav = function () {

  var activeClass = 'header-fixed--active',
      $header = $('.header-fixed') || null;

  $(window).on('scroll', stickyNavigation);
  $(window).bind('mousewheel', scrollUp);

  function stickyNavigation() {
    if ($header.length > 0) {
      var scrollTop = $(window).scrollTop(),
          headerOffestTop = $header.offset().top;

      if (scrollTop > headerOffestTop) {
        $header.removeClass('header-fixed--top');
      } else {
        $header.addClass('header-fixed--top');
      }
    }
  }

  function scrollUp(event) {

    if ($('.meganav').hasClass('meganav--show')) {
      return;
    } else if (event.originalEvent.wheelDelta >= 40) {
      $header.addClass(activeClass);
    } else if (event.originalEvent.wheelDelta <= 40 && event.originalEvent.wheelDelta >= 0) {
      if ($header.hasClass(activeClass)) {
        return;
      }
    } else {
      $header.removeClass(activeClass);
    }
  }
}();

theme.CollectionSlider = function () {

  var $slider = $('.collection-carousel'),
      $jsWatch = $('.js--watch ');

  function slider(x) {
    if ($(window).width() < 750) {
      if (!x.hasClass('slick-initialized')) {

        x.slick({
          arrows: true,
          vertical: false,
          slidesToShow: 3,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }, {
            breakpoint: 749,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true
            }
          }]
        });
      }
    } else {
      if (x.hasClass('slick-initialized')) {
        x.slick('unslick');
      }
    }
  }

  $jsWatch.bind("DOMSubtreeModified", function () {
    slider($('.js--watch .collection-carousel'));
    $jsWatch.unbind("DOMSubtreeModified");
  });

  slider($slider);

  $(window).resize(function () {
    slider($slider);
    if ($('.js--watch .collection-carousel')) {
      slider($('.js--watch .collection-carousel'));
    }
  });
}();

theme.Collection = function () {
  $('.collection-grid-item__match-height').matchHeight();
  $('.blog-grid-item__match-height').matchHeight();
}();

theme.CollectionFilter = function () {

  function deferFilterjQuery() {
    if (window.jQuery) {
      $(function () {
        // On load/reload
        var pt_on_load = function pt_on_load() {
          // Accordion
          $('.filter-menu .filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
          // $('.filter-menu .filter-group').not('.has_group_selected, .refine-header, .refine-header, .pt-display-dropdown').first().toggleClass('pt-group-expanded');

          // Search
          $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

          // Drop downs
          $('.pt-display-dropdown').each(function (index) {
            $(this).find('h4').after($(this).find('.filter-clear'));
          });

          $('.pt-display-dropdown .scroll-content').each(function (index) {
            if ($(this).find('li.selected').length) {
              var selected = $.map($(this).find('li.selected a'), function (element) {
                return $(element).text();
              }).join(", ");

              if (selected.length < 30) {
                $(this).before('<div class="menu-trigger">' + selected + '</div>');
              } else {
                $(this).before('<div class="menu-trigger">' + $(this).find('li.selected').length + ' Selected </div>');
              }
            } else {
              $(this).before('<div class="menu-trigger">' + $(this).closest('.filter-group').find('h4').text() + '</div>');
            }
          });

          // View more


          $('.filter-group ul:not(.has_selected)').each(function () {
            var max = 6;
            if ($(this).find("li:not(.selected)").length > max + 1) {
              $(this).find('li:gt(' + (max - 1) + '):not(.selected)').hide().end().append($('<li class="view-more-link"><a href="javascript:;">View More...</a></li>').click(function () {
                $(this).siblings(':hidden').slideDown(100).end().slideUp(100);
              }));
            }
          });
        };

        pt_on_load();

        // Mobile filter button

        $(document).on('click', '.pt-nav-toggle', function (e) {
          if (e.handled !== true) {
            if ($('.pt-nav-toggle').hasClass('active')) {
              $('.filter-menu').removeClass('pt-expand');
            } else {
              $('.filter-menu').addClass('pt-expand');
            }

            $('.pt-nav-toggle').toggleClass('active');
            e.preventDefault();
            e.handled = true;
          }
        });

        // Accordion

        $(document).on('click', '.filter-menu h4', function (e) {
          $(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
          e.preventDefault();
        });

        // Search
        $(document).on('keyup', '.filter-group input.fm-search-box', function () {
          var value = this.value.toLowerCase();
          $(this).closest('.filter-group').find('li').each(function () {
            if ($(this).text().toLowerCase().search(value) > -1) {
              $(this).show(100);
            } else {
              $(this).hide(100);
            }
          });
        });

        // Drop downs
        $(document).on('click', '.pt-display-dropdown .menu-trigger', function () {
          $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
          $(this).next('.scroll-content').slideToggle('fast');
        });

        $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function () {
          $(this).slideUp('fast');
        });
      });
    } else {
      setTimeout(function () {
        deferFilterjQuery();
      }, 50);
    }
  }

  deferFilterjQuery();
}();

theme.Search = function () {

  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('.search-hero form[action="/search"]').css('position', 'relative').each(function () {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');

    $('<div class="search-results"></div>').appendTo($('.search-results-wrapper')).hide();

    // Listening to keyup and change on the text field within these search forms.
    console.log(input);
    input.attr('autocomplete', 'off').bind('keyup change', function () {
      console.log("search init");
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + term + '*';
      // What's the search results list?
      var resultsList = $('.search-results');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        console.log("in the search");
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function (data) {
          console.log(data);
          // Reset results.
          if (resultsList.hasClass('slick-initialized')) {
            resultsList.slick('unslick');
          }
          resultsList.empty();

          // If we have no results.
          console.log(data);
          if (data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            // If we have results.
            $.each(data.results, function (index, item) {

              console.log(item);
              // var link = $('<a class="collection-grid-item__image-wrapper"></a>').attr('href', item.url);
              // link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
              // link.append('<span class="title">' + item.title + '</span>');
              // link.wrap('<li></li>');

              var link = "<div class='collection-grid-item'>" + "<a href='" + item.url + "' class='collection-grid-item__image-wrapper'>" + "<img src='" + item.thumbnail + "' class='collection-grid-item__no-hover lazyload blur-up' />" + "</a>" + "<div class='collection-grid-item__text-wrapper'>" + "<a href='" + item.url + "'>" + "<h3 class='h4 collection-grid-item__title'>" + item.title + "</h3>" + "<p class='collection-grid-item__price'>" + item.price + "</p>" + "</a>" + "</div>" + "</div>";

              resultsList.append(link);
            });

            // resultsList.slick({
            //   arrows:true,
            //   vertical:false,
            //   slidesToShow: 6,
            //   slidesToScroll: 1,
            //   centerMode: true,
            //   infinite: true
            // });

            resultsList.fadeIn(200);
          }
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  // $('body').bind('click', function(){
  //   $('.search-results').hide();
  // });
}();
/* ================= Search Popup ================= */
theme.SearchPopup = function () {

  if ($(".site-header__search-icon.full-screen-search").length != 0) {
    $(document).on('keydown', function (evt) {
      if (evt.keyCode === 27) {
        $('body > .search-hero').removeClass('search-hero--is-active');
      }
    });
    $('.search-hero__close').on('click', function (e) {
      $('body > .search-hero').removeClass('search-hero--is-active');
    });
    $('.site-header__search-icon').on('click', function (e) {
      $('body > .search-hero').addClass('search-hero--is-active');
      $(".search-hero__inner .search__input").focus();
      return false;
    });
  } else {
    $('.site-header__search-icon').on('click', function (e) {
      $('header .search-hero').addClass('search-small--is-active');
      $("header .search-hero__inner .search__input").focus();

      return false;
    });

    $('.search-hero__close').on('click', function (e) {
      $('header .search-hero').removeClass('search-small--is-active');
    });
  }
}();

theme.AjaxCart = function () {

  var selectors = {
    $form: $('form[action="/cart/add"]'),
    $cartCount: $('#CartCount, .cart-ajax__subtitle-counter'),
    $cartList: $('.cart-ajax__list'),
    $cartBody: $('.cart-ajax__wrapper'),
    $cartTotalPrice: $('.cart-ajax--total-price'),
    $cartClose: $('.cart-ajax__close'),
    $cartToggleBtn: $('#Cart-icon')
  };

  var storeCurrency = 'amount',
      cartOpened = false,
      cartPage = window.location.pathname;

  /* ----------------------------------------------------
  Add to cart functions
  -----------------------------------------------------*/
  selectors.$form.on('submit', function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;

    var $this = $(this),
        formData = $this.serialize(),
        $error = $this.find('.error');
    addToCart(formData, $error);
  });

  /* ----------------------------------------------------
  change cart functions and triggers
  -----------------------------------------------------*/
  $(document).on('click', '.cart-ajax__remove', function (event) {
    var $this = $(this);
    cartValueTrigger($this, 'remove');
  });

  $(document).on('focusout', '.cart-ajax .quantity-wrapper input', function (event) {
    var $this = $(this);
    cartValueTrigger($this);
  });

  $(document).on('click', '.cart-ajax .quantity-wrapper', function (event) {
    var $this = $(this);
    cartValueTrigger($this);
  });

  function cartValueTrigger(element, remove) {
    var $this = element,
        variantId = $this.closest('.cart-data').attr('data-id'),
        lineNo = $this.closest('.cart-data').attr('data-line'),
        input = $this.parent().find('input'),
        sendQuantity = parseInt(input.val());

    if (remove == 'remove') {
      var sendQuantity = 0;
    }

    changeCart(lineNo, sendQuantity, variantId);
  }

  /* ----------------------------------------------------
  Cart open and close functions
  -----------------------------------------------------*/
  selectors.$cartToggleBtn.on('click', function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    cartRender();
  });

  $(document).on('mouseup', function (event) {
    if (!selectors.$cartBody.is(event.target) && selectors.$cartBody.has(event.target).length === 0) {
      cartClose();
    }
  });

  selectors.$cartClose.on('click', function () {
    cartClose();
  });

  /* ----------------------------------------------------
  Below are all the functions for Add to cart, update cart and get cart data
  -----------------------------------------------------*/

  function addToCart(formData, $error) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      beforeSend: function beforeSend() {
        $error.addClass('error--hide');
      },
      success: function success(response) {
        cartRender();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')'),
            response = data.description;

        $error.html(response).removeClass('error--hide');
      }
    });
  }

  function changeCart(lineNo, quantity, variantId) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + lineNo,
      dataType: 'json',
      success: function success(response) {
        cartRender();
      }
    });
  }

  function getCartJSON(callback, x, y) {
    jQuery.getJSON('/cart.js', function (cart) {
      console.log(cart);
      callback(cart, x, y);
    });
  };

  /* ----------------------------------------------------
  Below are all the functions update the cart display - Ajax and cart page
  -----------------------------------------------------*/
  function cartRender() {
    if (cartPage === '/cart') {
      // getCartJSON(updateCartTotal);
      // getCartJSON(updateLineItems);
    } else {
      getCartJSON(cartBuild);
      if (cartOpened != true) {
        cartOpen();
      }
    }
    getCartJSON(cartCounter);
  };

  // Ajax Cart Open
  function cartOpen() {
    selectors.$cartBody.addClass('cart-ajax--show');
    cartOpened = true;
  };

  // Ajax Cart Close
  function cartClose() {
    selectors.$cartBody.removeClass('cart-ajax--show');
    cartOpened = false;
  }

  function cartCounter(cart) {
    selectors.$cartCount.html(cart.item_count);
    if (cart.item_count != 0) {
      selectors.$cartCount.addClass('cart-count--show');
    } else {
      selectors.$cartCount.removeClass('cart-count--show');
    }
  };

  function cartBuild(cart) {

    var items = cart.items,
        cartTotal = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);

    selectors.$cartList.html('');
    selectors.$cartTotalPrice.html('<span class=money>' + cartTotal + '</span>');

    $.each(items, function (i, item) {

      var cartRow = createMarkup(item, i);
      selectors.$cartList.append(cartRow);
    });

    relateProducts(cart);
  };

  function createMarkup(cart, loopCount) {

    var cartVariantTitle = cart.variant_title != null ? cart.variant_title : '',
        cartVariantPrice = slate.Currency.formatMoney(cart.price, theme.moneyFormat),
        cartLinePrice = slate.Currency.formatMoney(cart.line_price, theme.moneyFormat),
        cartLinePriceNew = cart.line_price,
        productHandle = cart.product_title.toLowerCase().replace(/ /g, "-"),
        loopCounter = loopCount + 1;

    if (cart.product_title == 'Jaded Neon Swim Pouch' && cart.quantity == 1 && cartLinePriceNew == '0.00') {
      var cartRow = '<div class="cart-ajax__row cart-data" data-line="' + loopCounter + '" data-id="' + cart.id + '"><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm cart-ajax__row__image" style="background-image: url(' + cart.image + ')"></a></div><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm h6 cart-ajax__row__title">' + cart.product_title + '<small class="cart-ajax__row__variant">Size : ' + cartVariantTitle + '</small> </a> <div class="quantity-wrapper"><div class="free-gift-text">FREE GIFT</div></div></div> <div class="cart-ajax__row__column"><div class="cart-ajax__remove">X</div><span class="cart-ajax__row__unit-price">Free</span></div></div>';

      // remove this after line price
      // <span class="cart-ajax__row__money">' + cartLinePrice + '</span>
    } else if (cart.product_title == 'Jaded Neon Swim Pouch' && cart.quantity == 1 && cartLinePriceNew == 1) {
      var cartRow = '<div class="cart-ajax__row cart-data" data-handle="' + productHandle + '" data-line="' + loopCounter + '" data-id="' + cart.id + '"><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm cart-ajax__row__image" style="background-image: url(' + cart.image + ')"></a></div><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm h6 cart-ajax__row__title">' + cart.product_title + '<small class="cart-ajax__row__variant">Size : ' + cartVariantTitle + '</small> </a> <div class="quantity-wrapper"><div class="free-gift-text">FREE GIFT</div></div></div> <div class="cart-ajax__row__column"><div class="cart-ajax__remove">X</div><span class="cart-ajax__row__unit-price">Free</span></div></div>';
    } else if (cart.product_title == 'Jaded Neon Sunglasses Case' && cartLinePriceNew == '0.00') {
      var cartRow = '<div class="cart-ajax__row cart-data" data-handle="' + productHandle + '" data-line="' + loopCounter + '" data-id="' + cart.id + '"><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm cart-ajax__row__image" style="background-image: url(' + cart.image + ')"></a></div><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm h6 cart-ajax__row__title">' + cart.product_title + '<small class="cart-ajax__row__variant">Size : ' + cartVariantTitle + '</small> </a> <div class="free-gift-text">FREE CASE WITH EACH PAIR</div><div class="quantity-wrapper"><div class="quantity-wrapper__minus js--quantity" data-increment="false">-</div><input type="number" value="' + cart.quantity + '" min="0"><div class="quantity-wrapper__plus js--quantity" data-increment="true">+</div></div></div><div class="cart-ajax__row__column"><div class="cart-ajax__remove">X</div></div></div>';
    } else if (cart.product_type == 'Sunglasses') {
      var cartRow = '<div class="cart-ajax__row cart-data" data-handle="' + productHandle + '" data-promo="sunglasses" data-line="' + loopCounter + '" data-id="' + cart.id + '"><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm cart-ajax__row__image" style="background-image: url(' + cart.image + ')"></a></div><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm h6 cart-ajax__row__title">' + cart.product_title + '<small class="cart-ajax__row__variant">Size : ' + cartVariantTitle + '</small> </a> <div class="quantity-wrapper"><div class="quantity-wrapper__minus js--quantity" data-increment="false">-</div><input type="number" value="' + cart.quantity + '" min="0"><div class="quantity-wrapper__plus js--quantity" data-increment="true">+</div></div></div><div class="cart-ajax__row__column"><div class="cart-ajax__remove">X</div><span class="cart-ajax__row__unit-price">' + cartVariantPrice + '</span></div></div>';
    } else {
      var cartRow = '<div class="cart-ajax__row cart-data" data-handle="' + productHandle + '" data-line="' + loopCounter + '" data-id="' + cart.id + '"><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm cart-ajax__row__image" style="background-image: url(' + cart.image + ')"></a></div><div class="cart-ajax__row__column"><a href="' + cart.url + '" class="js-click-gtm h6 cart-ajax__row__title">' + cart.product_title + '<small class="cart-ajax__row__variant">Size : ' + cartVariantTitle + '</small> </a> <div class="quantity-wrapper"><div class="quantity-wrapper__minus js--quantity" data-increment="false">-</div><input type="number" value="' + cart.quantity + '" min="0"><div class="quantity-wrapper__plus js--quantity" data-increment="true">+</div></div></div><div class="cart-ajax__row__column"><div class="cart-ajax__remove">X</div><span class="cart-ajax__row__unit-price">' + cartVariantPrice + '</span></div></div>';

      // remove this before the cart variant price
      //<span class="cart-ajax__row__money">' + cartLinePrice + '</span>
    }

    return cartRow;
  }

  function relateProducts(cart) {

    if ($(window).width() < 750) {
      return false;
    }
    var relateProducts = [],
        counter = 0;

    if (window.cartUpsell != undefined) {
      $.each(cartUpsell, function (i, item) {

        var collectionItem = item,
            collectionItemVar = collectionItem.variants[0].id,
            relateBoo = false;

        $.each(cart.items, function (i, cartItem) {
          if (cartItem.id == collectionItemVar) {
            relateBoo = true;
          }
        });

        if (relateBoo == false) {
          counter = counter + 1;
          var relatedProductImage = '<div class="cart-ajax__related__product-image" style="background-image:url(' + collectionItem.featured_image + ')"></div>',
              relatedProductTitle = '<h5 class="cart-ajax__related__product-title">' + collectionItem.title + '</h5><p class="cart-ajax__related__product-price">' + slate.Currency.formatMoney(collectionItem.price, theme.moneyFormat) + '</p>',
              relatedProduct = '<a href="/products/' + collectionItem.handle + '" class="cart-ajax__related__product-wrapper">' + relatedProductImage + relatedProductTitle + '</a>';

          relateProducts.push(relatedProduct);
        }
      });
    }
    if (relateProducts.length == 0) {
      $('.cart-ajax__related-title').addClass('cart-ajax__related-title--hide');
    } else {
      $('.cart-ajax__related-title').removeClass('cart-ajax__related-title--hide');
    }

    $('.cart-ajax__related').html(relateProducts);
  }

  // Cart Page
  function updateCartTotal(cart) {
    // selectors.$subTotalClass.html( moneyFormatter.format(storeCurrency, (cart.total_price/100)) );
    // selectors.$cartItems.html(cart.item_count);
  }

  function updateLineItems(cartdata) {
    // $.each(cartdata.items, function(i, item){

    //   var linePrice    = moneyFormatter.format(storeCurrency, (item.original_line_price/100)),
    //       lineQuantity = item.quantity,
    //       newLineData  = i + 1;

    //     $('.cart__row--' + item.id + ' .cart__line-total').html(linePrice)
    //     $('.cart__row--' + item.id + ' .cart-ajax__quantity__input').val(lineQuantity)
    //     $('.cart__row--' + item.id + ' .cart-data').attr('data-line', newLineData);
    // });
  }
}();

theme.Quantity = function () {

  $(document).on('click', '.js--quantity', function (e) {
    e.preventDefault();
    var $input = $(this).parent().find('input'),
        inputVal = parseInt($input.val()),
        sendQuantity = 0,
        incrementBoo = $(this).attr('data-increment'),
        increment = incrementBoo.toString(),
        totalSunglasses = 0;

    if (increment == 'true') {
      var newVal = inputVal + 1;
      $input.val(newVal);
    } else {
      if (inputVal - 1 != 0) {
        var newVal = inputVal - 1;
        $input.val(newVal);
      }
    }

    $("div[data-promo='sunglasses'] .quantity-wrapper input[type=number]").each(function () {
      totalSunglasses = parseInt($(this).val()) + totalSunglasses;
    });
    $('div.cart__row[data-handle="jaded-neon-sunglasses-case"] .quantity-wrapper input[type=number]').val(totalSunglasses);
    if (!$('body').hasClass('template-cart')) {
      // jQuery.post('/cart/update.js', {updates: {17337455509555: totalSunglasses}});
    }
    console.log('total = ' + totalSunglasses);
  });
}();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }
  console.log(Shopify);
  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {

    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
}();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login__left, .login__right').toggleClass('hide');
    $('.recover_wrapper').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
}();

theme.xs_currency = function () {
  console.log(this);
  var config = {
    select: $("#currency-select"),
    default_currency: $("#currency-select").attr('data-store'),
    current: $("#currency-select").attr('data-current')
  };

  if (config.default_currency == "" || config.default_currency == undefined) {
    return;
  }
  if (Currency.cookie.read() == "" || Currency.cookie.read() == undefined) {
    Currency.cookie.write(config.default_currency);
  }

  config.select.on("change", function () {
    var c = $(this).val();
    if (config.current != c) {
      Currency.convertAll(config.current, c, 'span.money');
      config.current = c;
      $(this).attr('data-current', c);
      display_currency(c);
    }
  });

  function display_currency(c) {
    $("[data-current-currency]").text(c);
  }
  config.select.val(config.current);
  if (Currency.cookie.read() != "" || Currency.cookie.read() != undefined) {
    var c = Currency.cookie.read();
  } else {
    var c = config.default_currency;
  }
  config.select.val(c).trigger('change');
}();
$(window).load(function () {
  if ($('#flashlight').length != 0) {
    setTimeout(function () {
      $('#flashlight').remove();
    }, 4000);
  }
  console.log("Window loaded");
  $('body').addClass('windowloaded');

  function showSearch() {
    $('nav .site-nav').hide();
    $('nav .top_search').addClass('open');
    $('nav .top_search input').focus();
    $('header .search_default').hide();
    $('header .search_active').show();
  }
  function hideSearch() {
    $('nav .site-nav').show();
    $('nav .top_search').removeClass('open');
    $('header .search_default').show();
    $('header .search_active').hide();
  }
  function switchRelated(a) {
    var show = a.attr('data-section');
    $('.s_section').hide();
    $('.s_section.' + show).show();
    $('.title_switcher > div').removeClass('active');
    a.addClass('active');
  }
  function showVideo(a) {
    var video = a.siblings('video');
    video.show().get(0).play();
    a.hide();
  }

  $(document).ready(function () {

    $('header .search_default').on('click', function () {
      showSearch();
    });
    $('header .search_active').on('click', function () {
      hideSearch();
    });
    $('.title_switcher > div').on('click', function () {
      switchRelated($(this));
    });

    $('.mob_play_video').on('click', function () {
      showVideo($(this));
    });
  });

  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  // sections.register('slideshow', theme.SlideshowSection);
  sections.register('notification-bar', theme.NotificationBarSection);
  sections.register('meganav', theme.MeganavSection);
  sections.register('size-guide', theme.SizeGuide);
});